import script from "./addClassPage.vue?vue&type=script&setup=true&lang=js"
export * from "./addClassPage.vue?vue&type=script&setup=true&lang=js"

import "./addClassPage.vue?vue&type=style&index=0&id=48ae0efa&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ae0efa"]])

export default __exports__